module.exports = __webpack_public_path__ + "img/img2.a5f074f0.svg";